import { useTranslation } from "react-i18next";
import type { ConsentTopic, TopicKey } from "../../api/consent";
import ConsentGateList from "./ConsentGateList";

/**
 * Before you start (Figma "Web / Privacy / Before you start" 4435:3414 / 4435:3530, existing user 4443:4762 /
 * 4443:4810; Dark 4436:4524 / 4436:4632 / 4443:4858 / 4443:4906): the terms box and the privacy-notice line
 * (Required) plus the web device items this browser has not answered (Optional), one confirm.
 * - `mode="new"`: before the account exists; Decline = no account (the caller goes back to sign in, no request).
 * - `mode="existing"`: signed in, the gate is pending; Decline and sign out.
 */
export default function BeforeYouStart({
  mode,
  required,
  optional,
  onConfirm,
  onDecline,
}: {
  mode: "new" | "existing";
  required: ConsentTopic[];
  optional: ConsentTopic[];
  onConfirm: (ticked: Set<TopicKey>) => Promise<void>;
  onDecline: () => Promise<void> | void;
}) {
  const { t } = useTranslation();
  return (
    <ConsentGateList
      testId="consent-bys"
      title={t("consent_bys_title")}
      text={t("consent_bys_text")}
      required={required}
      optional={optional}
      optionalTitle={t("consent_group_optional")}
      termsKeys={["consent_bys_terms_before", "consent_bys_terms_link", "consent_bys_terms_after"]}
      declineLabel={mode === "new" ? t("consent_decline") : t("consent_decline_sign_out")}
      onConfirm={onConfirm}
      onDecline={onDecline}
    />
  );
}
